import { CHANNEL_BINDINGS, ID_PREFIX } from 'modules/channels/constants';
import { useChannelsContext } from 'modules/channels/contexts';
import { BindingError, UpdateChannelFormState } from 'modules/channels/types';
import { createBindingsError, createOptionsList, createUniqueId } from 'modules/channels/utils';
import { useController } from 'react-hook-form';
import { Add16 } from 'ui/icons';
import { GhostSuccessButton } from 'ui/button';
import { Actions, SplitInputWrapper } from '../Styled';
import { PercentageBanner } from './PercentageBanner';
import { SplitInput } from './SplitInput';

export const SPLIT_INPUT_TEXT = {
  ADD_BUTTON_LABEL: 'Add new binding',
  PLACEHOLDER: 'Select an ESP account',
};

export const SendingPlatformAccounts = () => {
  const { espAccounts } = useChannelsContext();
  const {
    field: { onChange, value },
    formState: {
      errors: { channelBindings: channelBindingsError },
    },
  } = useController<UpdateChannelFormState, 'channelBindings'>({
    name: CHANNEL_BINDINGS,
  });

  const espOptions = createOptionsList({ accounts: espAccounts, options: value });

  const handleAddBinding = () => {
    const valueIds = value.map((val) => val.id);
    const uniqueId = createUniqueId(valueIds, ID_PREFIX, valueIds.length);
    const newValues = [...value, { id: uniqueId, option: '', num: '10' }];
    onChange(newValues);
  };

  const handleRemoveBinding = (id: string) => {
    const filteredValues = value.filter((binding) => {
      return binding.id !== id;
    });
    onChange(filteredValues);
  };

  const handleChangeBinding = (itemToUpdate: { id: string; name: string; value: string }) => {
    const updatedBindings = value.map((currentValue) => {
      const isCurrent = currentValue.id === itemToUpdate.id;
      return isCurrent
        ? { ...currentValue, [itemToUpdate.name]: itemToUpdate.value }
        : currentValue;
    });

    onChange(updatedBindings);
  };

  const splitInputErrors = createBindingsError(channelBindingsError as BindingError);

  return (
    <SplitInputWrapper>
      <SplitInput
        errors={splitInputErrors}
        hasRemove={value.length > 1}
        options={espOptions}
        onChange={handleChangeBinding}
        onRemove={handleRemoveBinding}
        placeholder={SPLIT_INPUT_TEXT.PLACEHOLDER}
        items={value}
      />
      <PercentageBanner channelBindings={value} />
      <Actions>
        <GhostSuccessButton
          isDisabled={espOptions?.length <= value.length}
          onClick={handleAddBinding}
        >
          <Add16 />
          <span>{SPLIT_INPUT_TEXT.ADD_BUTTON_LABEL}</span>
        </GhostSuccessButton>
      </Actions>
    </SplitInputWrapper>
  );
};
